import GD from '../GD'
import { ErrorsAPI } from '../enums/errorsAPI'
import { Config } from '../managers'
import { detectOS } from './Helpers'

interface ICall {
  url: string
  request: APIRequest
  encrypt: boolean
}

const app = detectOS()

class DCCAPI {
  static base = 'qIWDHpg9FCzUAQNJ8XfML0yORZeY5B4PT7anmkjGE1bv6dxoh3lrS2tVwiscKu'
  public debug = true
  public log?: (txt: string) => void

  static getBaseNumber(sourceNumber: number): string {
    const r = sourceNumber % 62
    let result: string

    if (sourceNumber - r === 0)
      result = DCCAPI.base.charAt(r)
    else
      result = DCCAPI.getBaseNumber((sourceNumber - r) / 62) + '' + DCCAPI.base.charAt(r)
    return result
  }

  static unpack(str: string, key: string): string {
    if (!key)
      return 'NO KEY'
    if (!str)
      return ''

    const keyLen = key.length
    const strLen = str.length
    if (strLen % 2 !== 0)
      return str

    let m = 0
    let n = 0
    let decoded = ''
    while (m < strLen) {
      let code: number
      let i: string
      let mStep = 2
      if (str.charAt(m) === '-') {
        i = str.charAt(m + 1) + '' + str.charAt(m + 2) + '' + str.charAt(m + 3)
        code = DCCAPI.getNumberByBase(i)
        mStep = 4
      }
      else {
        i = str.charAt(m) + '' + str.charAt(m + 1)
        if (str.charAt(m) === '.')
          i = str.charAt(m + 1)
        code = DCCAPI.getNumberByBase(i)
      }
      code -= key.charCodeAt(n)
      decoded += String.fromCharCode(code)
      n++
      if (n === keyLen)
        n = 0
      m += mStep
    }
    return decoded
  }

  static pack(str: string, key: string): string | null {
    const keyLen = key.length
    if (keyLen === 0)
      return null
    let encoded = ''
    let m = 0
    let n = 0
    while (n < str.length) {
      let chr = DCCAPI.getBaseNumber(str.charCodeAt(n++) + key.charCodeAt(m))
      if (chr.length === 1) {
        chr = '.' + chr
      }
      if (chr.length === 3) {
        encoded += '-' + chr
      }
      else {
        encoded += chr
      }
      m++
      if (m === keyLen)
        m = 0
    }
    return encoded
  }

  static getNumberByBase(baseString: string): number {
    let m = baseString.length - 1
    let res = 0
    let pow = 0
    while (m > -1)
      res += DCCAPI.base.indexOf(baseString.charAt(m--)) * Math.pow(62, (pow++))
    return res
  }

  call({ url, request, encrypt }: ICall): Promise<APIResponse> {
    if (this.debug) {
      let debug = '\t' + url + '\n'
      debug += '\tRequest:\n'
      for (const n in request) {
        if (n.indexOf('pass') > -1) {
          debug += '\t\t' + n + ': ******\n'
        }
        else {
          let val = request[n]
          if (typeof val == 'object') {
            let str = '\n\t\t\t'
            if (Array.isArray(val))
              str += '['
            else
              str += '{'
            str += '\n'
            for (const i in val) {
              str += '\t\t\t\t' + i + ': ' + val[i] + '\n'
            }
            if (Array.isArray(val))
              str += '\t\t\t]'
            else
              str += '\t\t\t}'
            val = str
          }
          if (val && val.length > 96)
            val = val.substr(0, 96) + '...'
          debug += '\t\t' + n + ': ' + val + '\n'
        }
      }
      if (this.log)
        this.log(debug)
    }

    const secret = '12345678901234567890123456789012'

    if (request.url) delete request.url

    const form = new FormData()
    if (encrypt) {
      const result = DCCAPI.pack(JSON.stringify(request), secret)
      form.set('cdata', secret + result)
    }
    else {
      for (const i in request)
        form.set(i, request[i])
    }

    const xhr = new XMLHttpRequest()
    const extendedUserAgent = `${navigator.userAgent} | version=${Config.version} | app=${app} | user=${request.key}`

    xhr.open('post', url)
    xhr.setRequestHeader('x-dccapi-useragent', extendedUserAgent)
    xhr.send(form)

    return new Promise((resolve, reject) => {
      xhr.onload = () => {
        if (xhr.status > 399) {
          resolve({
            error: true,
            errorMsg: 'js...03 wrong http code: ' + xhr.status,
            data: null
          })
        }
        xhr.onload = null
        xhr.onerror = null
        const result = this.finish(xhr.response)
        resolve(result)
      }
      xhr.onerror = () => {
        xhr.onload = null
        xhr.onerror = null
        reject({
          error: true,
          errorMsg: 'js...01 load error, code:' + xhr.status,
          data: null
        })
      }
    })
  }

  finish(data: string) {
    if (!data || data.length === 0) {
      return {
        error: true,
        errorMsg: 'js...01 no data',
        data: null
      }
    }
    let obj: APIResponse | null
    try {
      obj = JSON.parse(data)
    }
    catch (e: unknown) {
      console.error(e)

      return {
        error: true,
        errorMsg: 'js...02 wrong json',
        data: data || null
      }
    }

    if (obj != null && obj.status != null && obj.status.error) {
      if (obj.status.errorCode === ErrorsAPI.UNAUTHORIZED_1 || obj.status.errorCode === ErrorsAPI.UNAUTHORIZED_2) {
        GD.LOGOUT.invoke()
      }

      return {
        error: true,
        errorMsg: obj.status.errorMsg,
        data: null
      }
    }
    return {
      error: false,
      errorMsg: null,
      data: obj?.data
    }
  }
}

export { DCCAPI }
